/// <reference types="@types/googlemaps" />

import { Component, OnInit } from '@angular/core';
import { DataService } from '../../core/data/data.service';
import { ActivatedRoute, Router } from '@angular/router';

import {
  FindNearestLocationsByCoordinatesGQL,
  LocationType,
  ProductName
} from '../../core/graphql-client/graphql';
import { Environment } from '../../core/environment';

@Component({
  selector: 'finders-location-search',
  templateUrl: './location-search.component.html',
  styleUrls: ['./location-search.component.scss']
})
export class LocationSearchComponent implements OnInit {
  public latitude: string;
  public longitude: string;
  public locationSite: string;
  public locationType: LocationType;
  public locationAddress: string;
  public results: any;
  public searching = false;

  constructor(
    private findNearestLocationsByCoordinatesGQL: FindNearestLocationsByCoordinatesGQL,
    private data: DataService,
    private router: Router,
    private route: ActivatedRoute,
    public env: Environment
  ) {
    this.results = [];
  }

  ngOnInit() {
    // If we're linking directly to the map use this
    this.route.params.subscribe(params => {
      this.results = [];
      this.latitude = params['latitude'];
      this.longitude = params['longitude'];
      this.locationType = params['type'];

      console.log('PARAMS', params);

      if (
        this.latitude === undefined ||
        this.longitude === undefined ||
        this.locationType === undefined
      ) {
        this.searching = false;
      } else {
        this.searching = true;
        this.findNearestLocationsByCoordinates();
      }
    });
  }

  public locationTypeChanged(locationType) {
    this.locationType = <LocationType>locationType;
    if (this.locationAddress === undefined) {
    } else {
      this.findNearestLocationsByCoordinates();
    }
  }

  private trimDistance(distance) {
    const trimmed = distance.substring(0, 4);
    if (trimmed.endsWith('.')) {
      return trimmed.substring(0, 3);
    } else {
      return trimmed;
    }
  }

  public findNearestLocationsByCoordinates() {
    this.results = [];
    this.searching = true;

    this.findNearestLocationsByCoordinatesGQL
      .watch({
        longitude: this.longitude,
        latitude: this.latitude,
        locationType: this.locationType,
        // productName: ProductName.Prolia,
        productName: this.env.product,
        limitLocations: 10,
        limitDistance: 300
      })
      .valueChanges.subscribe(({ data }) => {
        let counter = 1;

        for (const loc of data.findNearestLocationsByCoordinates) {
          this.results.push({
            ...loc,
            distance: this.trimDistance(loc.distance),
            label: (counter++).toString(),
            active: false
          });
        }

        this.searching = false;
        return this.results;
      });
  }
  // this.latitude, this.longitude, this.locationType
  public editLocation(result) {
    this.data.changeMessage({
      location: result,
      locationType: this.locationType
    });
    this.router.navigate(['location/edit']);
  }
}
